<template>
  <el-card class="card" :body-style="{
    padding: '0px',
    position: 'relative',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    justifyContent: 'space-between'
  }">
    <div class="card-burst" v-if="burst">
      <span v-html="burst" class="card-burst-text"></span>
    </div>
    <div>
      <div class="card-image-container" :style="{ backgroundImage: `url(${image})` }">
      </div>
      <div class="card-text">
        <p class="card-subhead">{{ subhead }}</p>
        <h3>{{ headline }}</h3>
        <div class="card-blurb" v-html="copy">
        </div>
      </div>
    </div>
    <div class="card-link" v-if="hasLink">
      <a class="arrow" :href="linkUrl">
        {{ linkText }}
      </a>
    </div>
  </el-card>
</template>

<script>

export default {
  name: 'RegionalHighlight',
  props: {
    regionalHighlight: {
      required: true,
      type: Object,
    },
  },
  computed: {
    burst() {
      return this.regionalHighlight.regionalHighlightBurst;
    },
    image() {
      return this.regionalHighlight.regionalHighlightImage[0].url;
    },
    subhead() {
      return this.regionalHighlight.regionalHighlightSubhead;
    },
    headline() {
      return this.regionalHighlight.regionalHighlightHeadline;
    },
    copy() {
      return this.regionalHighlight.regionalHighlightCopy;
    },
    hasLink() {
      return this.regionalHighlight.regionalHighlightLink.length > 0;
    },
    linkUrl() {
      return (this.regionalHighlight.regionalHighlightLink.length > 0) ?
        this.regionalHighlight.regionalHighlightLink[0].linkUrl : '';
    },
    linkText() {
      return (this.regionalHighlight.regionalHighlightLink.length > 0) ?
        this.regionalHighlight.regionalHighlightLink[0].linkText : '';
    },
  }
}

</script>

<style lang="scss" scoped>
@import 'element-theme-chalk/src/mixins/mixins.scss';
@import '@/assets/base/_variables.scss';

.card {
  margin-right: 25px;
  margin-left: 25px;
  margin-bottom: 25px;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
  height: 100%;

  &:deep(.card-blurb) {
    font-size: 1rem;
    color: $--color-grayscale-5;

    p {
      font-size: 1rem;
      color: $--color-grayscale-5;
    }
  }

}

.card-image-container {
  width: 100%;
  background-repeat: no-repeat;
  background-size: cover;
  padding-top: 45%;
}

.card-text {
  padding-right: 40px;
  padding-left: 40px;
  padding-bottom: 5px;
  padding-top: 30px;
}

.card-link {
  padding-right: 40px;
  padding-left: 40px;
  padding-bottom: 40px;
}

.card-subhead {
  font-size: 0.9375rem;
  text-transform: uppercase;
  line-height: 1.125rem;
  margin-top: 0px;
  margin-bottom: 12px;
  font-weight: 700;
  color: $--color-grayscale-5;
}

.card-burst {
  position: absolute;
  top: 0;
  right: 0;
  color: $--color-white;
  text-transform: uppercase;
  font-size: 12px;
  font-weight: 700;
  background-color: transparent;
  background-repeat: no-repeat;
  background-image: url('@/assets/images/burst-graphic.svg');
  text-align: right;
  padding-top: 14px;
  width: 120px;
  height: 43px;
}

.card-burst-text {
  padding-right: 30px;
}



h3 {
  color: $--color-secondary;
  margin-bottom: 30px;
}

a {
  text-transform: uppercase;
  font-size: 0.875rem;
}

@include res(sm-and-down, $--breakpoints-spec) {
  h3 {
    font-size: 1.5625rem;
    margin-bottom: 24px;
    line-height: 1.75rem;
  }



  .card-text {
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 10px;
  }

  .card {
    margin: 0;
  }

  .card-subhead {
    font-size: 0.75rem;
  }

  .card-link {
    padding-right: 20px;
    padding-left: 20px;
  }

  a {
    font-size: 0.8125rem;
  }
}
</style>

